import { usePlatformSettings } from '@/hooks';
import { FaWhatsapp } from 'react-icons/fa';

export function WhatsAppBubble() {
  const { data: settings } = usePlatformSettings();

  if (!settings?.whatsappNumber || !settings?.whatsappEnabled) return null;

  const cleanNumber = settings.whatsappNumber.replace(/\D/g, '');
  const message = settings.whatsappMessage
    ? `?text=${encodeURIComponent(settings.whatsappMessage)}`
    : '';

  return (
    <a
      href={`https://wa.me/${cleanNumber}${message}`}
      target="_blank"
      rel="noopener noreferrer"
      // Abaixo de lg, deixa 32 px acima da barra, além da área segura do celular.
      className="group fixed bottom-[calc(6rem+env(safe-area-inset-bottom,0px))] right-4 z-40 lg:bottom-10 lg:right-8 lg:z-50"
      aria-label="Fale conosco no WhatsApp"
    >
      <div className="relative">
        {/* Pulse ring */}
        <div className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" />

        {/* Button */}
        <div className="relative flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl sm:h-14 sm:w-14">
          <FaWhatsapp className="h-7 w-7 text-white" aria-hidden="true" />
        </div>

        {/* Tooltip */}
        <div className="pointer-events-none absolute bottom-full right-0 mb-3 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <div className="bg-card border-border/50 whitespace-nowrap rounded-lg border px-3 py-2 text-sm font-medium shadow-lg">
            Fale conosco
            <div className="bg-card border-border/50 absolute right-5 top-full h-2 w-2 -translate-y-1 rotate-45 transform border-b border-r" />
          </div>
        </div>
      </div>
    </a>
  );
}
